import { fromJS } from 'immutable';

import { createReducer } from 'reducers/utils/helpers';
import { lastUpdated } from 'utils/DateHelper';

import {
  conversationsData,
  OPEN_CONVERSATIONS_PANEL,
  CLOSE_CONVERSATIONS_PANEL,
  SET_CONVERSATION_FILTERS,
} from './types';

export * from './actions';

const initialState = fromJS({
  isOpen: true,
  prospects: [],
  conversations: [],
  conversationId: null,
  network: {
    loading: false,
    error: false,
    success: false,
  },
  lastUpdated: null,
});

export default createReducer(initialState, {
  [OPEN_CONVERSATIONS_PANEL]: (state) =>
    state.withMutations((mutableState) => mutableState.set('isOpen', true)),
  [CLOSE_CONVERSATIONS_PANEL]: (state) =>
    state.withMutations((mutableState) => mutableState.set('isOpen', false)),
  [SET_CONVERSATION_FILTERS]: (state, { prospects, conversationId }) =>
    state.withMutations((mutableState) =>
      mutableState.set('prospects', prospects).set('conversationId', conversationId),
    ),
  [conversationsData.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [conversationsData.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['conversations'], action.response)
        .setIn(['lastUpdated'], lastUpdated(action.response)),
    ),
  [conversationsData.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
});
